import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Input, Checkbox, Form, Upload, Image } from 'antd';
import LoadableButton from "../../../../../components/buttons/LoadableButton.jsx";
import { DepositAmountApi } from '../../../../../api/request/wallet/cashdeposit.js';

const ZinaCardPayment = ({ amount, resetAll, QrCode, loginTerminalId }) => {
    const [form] = Form.useForm();
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [signatureFileList, setSignatureFileList] = useState([]);

    const getBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

    const extractOriginFileObjs = (fileArray) => {
        return fileArray ? fileArray.map((file) => file.originFileObj) : [];
    };

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
             if (!amount) {
                toast.error('Please enter deposit amount');
                return;
            }
            const UploadDocument = extractOriginFileObjs(values?.UploadDocument);
            const isWallet = loginTerminalId === 'wallet';
            let formData = new FormData();
            formData.append("UserId", userDetails?.id);
            formData.append("ReferenceId", values?.ReferenceId);
            formData.append("Comment", values?.Comment || "");
            formData.append("Amount", Number(amount));
            formData.append("DepositType", 5);
            formData.append("loginTerminalId", isWallet ? 0 : loginTerminalId);
            UploadDocument.forEach((file) => formData.append("PaymentProof", file));

            let apiHeaders = { headers: { Accept: "application/json", "Content-Type": "multipart/form-data" } };

            const { data } = await DepositAmountApi(formData, apiHeaders);
            if (data?.success) {
                toast.success(data?.message);
                setSignatureFileList([]);
                form.resetFields();
                resetAll();
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Deposit failed.');
        } finally {
            setIsLoading(false);
        }
    }

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const handleSignatureChange = ({ fileList: newSignatureList }) => {
        setSignatureFileList(newSignatureList);
        form.setFieldsValue({ UploadDocument: newSignatureList });
    };

    const UploadButton = (
        <button type="button">
            <div className='flex items-center justify-center gap-2 border rounded-md py-1.5 px-4 text-lg text-gray-500 font-medium'>
                <img src="/assets/icons/Upload_Document_icon.svg" alt="icon" className='h-5' />
                <span>Click to Upload</span>
            </div>
        </button>
    );

    return (
        <div className="grid sm:grid-cols-2 gap-3 items-center">
            <div className="text-center ">
                <h3 className="text-lg font-semibold text-gray-700 mb-4">Scan QR Code to Pay</h3>
                <div >
                    <div className="flex justify-center ">
                        <img src={`${QrCode}`} alt="QR Code" className="w-80 h-80 border border-gray-300 rounded-lg" />
                    </div>
                </div>
            </div>
            <Form form={form} layout="vertical" className='space-y-5 mt-5' onFinish={handleSubmit}>
                <Form.Item
                    name='ReferenceId'
                    label={<span className="text-lg text-gray-500 font-medium">Transaction ID</span>}
                    rules={[{ required: true, message: 'Please enter transaction id.' }]}
                >
                    <Input placeholder="Transaction ID" size='large' />
                </Form.Item>

                <Form.Item
                    name='Comment'
                    label={<span className="text-lg text-gray-500 font-medium">Comment</span>}
                >
                    <Input placeholder="Comment" size='large' />
                </Form.Item>

                <Form.Item
                    name="UploadDocument"
                    label={<span className="text-lg text-gray-500 font-medium">Upload Document</span>}
                    rules={[{ required: true, message: 'Please Upload Document.' }]}
                >
                    <Upload
                        beforeUpload={() => false}
                        listType="picture"
                        className="mt-1"
                        fileList={signatureFileList}
                        onPreview={handlePreview}
                        onChange={handleSignatureChange}
                    >
                        {signatureFileList.length >= 1 ? null : UploadButton}
                    </Upload>
                </Form.Item>

                {previewImage && (
                    <Image
                        src={previewImage}
                        wrapperStyle={{ display: 'none' }}
                        preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) => setPreviewOpen(visible),
                            afterOpenChange: (visible) => !visible && setPreviewImage(''),
                        }}
                    />
                )}

                <Form.Item
                    name='conditions'
                    valuePropName="checked"
                    rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')) }]}
                >
                    <Checkbox className='mt-4'>
                        Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300'>Terms and conditions</Link>
                    </Checkbox>
                </Form.Item>
                <div className='text-center'>
                    <LoadableButton
                        className='bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase sm:w-auto w-full'
                        type="Submit"
                        lable='Submit'
                        isLoading={isLoading}
                        loadingLable='Adding request...'
                    />
                </div>
            </Form>
        </div>
    )
}

export default ZinaCardPayment
